/* Puleia flu landing — every CTA on the page routes into the ONE real product form (incl. Kaching bundles). */
(function () {
  if (window.__fluLanding) return;
  window.__fluLanding = true;

  function buyBox() {
    return (
      document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function productForm() {
    var box = buyBox();
    return (box && box.querySelector('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]');
  }

  // Select the 1/2/3 bundle in the buy box. Kaching first, theme quantity input as fallback.
  function selectBundle(index) {
    if (!index) return;
    var bars = document.querySelectorAll(
      'kaching-bundles-block .kaching-bundles__bar'
    );
    if (bars.length >= index) {
      var bar = bars[index - 1];
      var input = bar.querySelector('input[type="radio"]');
      (input || bar).click();
      return;
    }
    var form = productForm();
    var qty = form && (form.querySelector('input[name="quantity"]') || document.querySelector('quantity-input input[name="quantity"]'));
    if (qty) {
      qty.value = index;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function scrollToBuy() {
    var target = document.querySelector('kaching-bundles-block') || productForm() || buyBox();
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function addToCart() {
    var form = productForm();
    var btn = form && form.querySelector('[type="submit"][name="add"], button[type="submit"]');
    if (btn && !btn.disabled) btn.click();
    else scrollToBuy();
  }

  // Copy live bundle prices from the Kaching deal bars into the offer cards.
  function syncPrices() {
    var cards = document.querySelectorAll('[data-flu-price]');
    if (!cards.length) return true;
    var bars = document.querySelectorAll('kaching-bundles-block .kaching-bundles__bar');
    if (!bars.length) return false;
    cards.forEach(function (card) {
      var bar = bars[parseInt(card.getAttribute('data-flu-price'), 10) - 1];
      if (!bar) return;
      var price = bar.querySelector('.kaching-bundles__bar-price');
      var full = bar.querySelector('.kaching-bundles__bar-full-price');
      if (!price) return;
      var p = price.textContent.trim();
      var f = full ? full.textContent.trim() : '';
      var qty = parseInt(card.getAttribute('data-flu-qty') || '1', 10);
      var cents = parseFloat(p.replace(/[^0-9.]/g, ''));
      var per = qty > 1 && cents ? '<span class="flu-per">' + p.replace(/[0-9.,]+/, (cents / qty).toFixed(2)) + ' per bottle</span>' : '';
      card.innerHTML = '<strong>' + p + '</strong>' + (f && f !== p ? '<s>' + f + '</s>' : '') + per;
    });
    return true;
  }
  // Replace Kaching's bundle box title on this page only (text comes from the Flu hero block setting).
  function retitleKaching() {
    var src = document.querySelector('[data-flu-kaching-title]');
    if (!src) return true;
    var t = document.querySelector('kaching-bundles-block .kaching-bundles__block-title');
    if (!t) return false;
    var text = src.getAttribute('data-flu-kaching-title');
    var apply = function () {
      var el = document.querySelector('kaching-bundles-block .kaching-bundles__block-title');
      if (el && el.textContent !== text) { el.textContent = text; }
      if (el) el.classList.add('flu-kwarn');
    };
    apply();
    // Kaching re-renders on selection changes; keep our title.
    var block = document.querySelector('kaching-bundles-block');
    if (block && !block.__fluObs) {
      block.__fluObs = new MutationObserver(apply);
      block.__fluObs.observe(block, { childList: true, subtree: true, characterData: true });
    }
    return true;
  }

  // Add to cart (Cleanora layout): "Add To Cart · $54.98 $83.97" + guarantee line, price follows the selected Kaching bundle.
  function enhanceAtc() {
    var src = document.querySelector('[data-flu-atc]');
    if (!src) return true;
    var btn = document.getElementById('ProductSubmitButton-' + src.getAttribute('data-flu-atc'));
    if (!btn) return false;
    if (!btn.dataset.fluAtc) {
      btn.dataset.fluAtc = '1';
      var label = btn.querySelector('.main-atc__label') || btn;
      var price = document.createElement('span');
      price.className = 'flu-atc-price';
      price.setAttribute('aria-hidden', 'true');
      price.innerHTML = '<span class="flu-atc-price__dot">&middot;</span><span class="flu-atc-price__now"></span><span class="flu-atc-price__was"></span>';
      label.appendChild(price);
      var g = src.getAttribute('data-flu-atc-guarantee');
      if (g) {
        var line = document.createElement('span');
        line.className = 'flu-atc-g';
        line.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l8 3v6c0 5.2-3.4 9.4-8 11-4.6-1.6-8-5.8-8-11V5l8-3zm-1.1 13.6l5.6-5.6-1.4-1.4-4.2 4.2-2-2-1.4 1.4 3.4 3.4z"/></svg>';
        var t = document.createElement('span');
        t.textContent = g;
        line.appendChild(t);
        btn.appendChild(line);
      }
    }
    var p = btn.querySelector('.flu-atc-price');
    var sel = document.querySelector('kaching-bundles-block .kaching-bundles__bar--selected');
    var now = sel && sel.querySelector('.kaching-bundles__bar-price');
    var was = sel && sel.querySelector('.kaching-bundles__bar-full-price');
    if (!now) { p.style.display = 'none'; btn.classList.remove('flu-atc-ready'); return false; }
    p.style.display = '';
    btn.classList.add('flu-atc-ready');
    p.querySelector('.flu-atc-price__now').textContent = now.textContent.trim();
    var w = was ? was.textContent.trim() : '';
    var wasEl = p.querySelector('.flu-atc-price__was');
    wasEl.textContent = w;
    wasEl.style.display = w && w !== now.textContent.trim() ? '' : 'none';
    if (!btn.__fluObs) {
      var k = document.querySelector('kaching-bundles-block');
      if (k && window.MutationObserver) {
        btn.__fluObs = new MutationObserver(function () { enhanceAtc(); });
        btn.__fluObs.observe(k, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true, characterData: true });
      }
    }
    return true;
  }

  var tries = 0;
  (function waitForKaching() {
    enhanceAtc();
    var a = syncPrices(), b = retitleKaching();
    if ((a && b) || ++tries > 40) return;
    setTimeout(waitForKaching, 250);
  })();

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-flu-cta]');
    if (!el) return;
    e.preventDefault();
    var bundle = parseInt(el.getAttribute('data-flu-bundle') || '0', 10);
    selectBundle(bundle);
    if (el.getAttribute('data-flu-cta') === 'add') {
      setTimeout(addToCart, bundle ? 450 : 0);
    } else {
      scrollToBuy();
    }
  });
})();
